// The author's lore for ONE story or ONE conversation (src/threadLore.js).
import { useState, useContext } from 'react';
import { ThemeContext } from './ThemeContext.jsx';
import { saveThreadLore, THREAD_LORE_MAX } from './threadLore.js';

export default function ThreadLorePanel({ threadType, threadId, threadName, initial = '', onSaved, onClose, isMobile }) {
  const { theme: t } = useContext(ThemeContext);
  const [text, setText] = useState(initial || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const scope = threadType === 'story' ? 'story' : 'conversation';

  const save = async () => {
    if (busy) return;
    setBusy(true); setError(null);
    const r = await saveThreadLore(threadType, threadId, text);
    setBusy(false);
    if (!r.ok) { setError(r.error || 'could not save'); return; }
    onSaved?.(r.lore);
    onClose?.();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9400, background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: isMobile ? 'stretch' : 'center', justifyContent: 'center', padding: isMobile ? 0 : '20px' }} onClick={onClose}>
      <div className="bq-leaf" style={{ width: '100%', maxWidth: '640px', maxHeight: isMobile ? '100dvh' : '85vh', display: 'flex', flexDirection: 'column', background: 'var(--ds-surface-1, #150b0d)', border: '1px solid var(--ds-line)', borderRadius: isMobile ? 0 : 'var(--ds-r-xl, 20px)', overflow: 'hidden' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 16px', borderBottom: '1px solid var(--ds-line-soft)' }}>
          <span style={{ fontSize: '20px' }}>📜</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700, color: t.textPrimary, fontFamily: "'Cinzel', serif", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>This {scope}'s lore{threadName ? ` — ${threadName}` : ''}</div>
            <div style={{ fontSize: '11px', color: t.textMuted }}>What you write here is true in this {scope} only, above the character's profile and the world's defaults. Every reply here reads it.</div>
          </div>
          <button onClick={onClose} aria-label="Close the lore panel" style={{ background: 'none', border: 'none', color: t.textMuted, cursor: 'pointer', fontSize: '18px' }}>✕</button>
        </div>
        <div style={{ flex: 1, padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: '8px', minHeight: 0 }}>
          <textarea value={text} onChange={e => setText(e.target.value.slice(0, THREAD_LORE_MAX))} rows={isMobile ? 14 : 12} aria-label={`Lore for this ${scope}`}
            placeholder={`The rules, places, people and history that hold in this ${scope}. Example: "Alistair is still mortal here. The Court has not fallen. Kya's sister lives in the north wing."`}
            style={{ flex: 1, width: '100%', boxSizing: 'border-box', padding: '12px', borderRadius: '10px', border: '1px solid var(--ds-line)', background: 'var(--ds-input, #1a1012)', color: t.textPrimary, fontSize: '14px', lineHeight: 1.5, fontFamily: 'inherit', resize: 'vertical' }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '11px', color: t.textMuted }}>{text.length} / {THREAD_LORE_MAX}</span>
            {error && <span style={{ fontSize: '12px', color: '#ed4245' }}>{error}</span>}
            <button onClick={save} disabled={busy} style={{ marginLeft: 'auto', padding: '8px 16px', borderRadius: '10px', border: 'none', background: 'var(--ds-gold, #c4a882)', color: '#1a1012', fontWeight: 700, cursor: busy ? 'wait' : 'pointer' }}>{busy ? 'Saving…' : 'Save lore'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
